import { useEffect, useState } from 'react';

interface CountdownOptions {
  target_timestamp?: number | null;
}

export function useCountdown({ target_timestamp }: CountdownOptions) {
  const [is_time_passed, setIsTimePassed] = useState(!target_timestamp);
  useEffect(() => {
    if (!target_timestamp) return;

    function checkTime(ts: number) {
      const now = Date.now();
      const passed = now >= ts;

      setIsTimePassed(passed);

      if (passed) {
        clearInterval(intervalId);
      }
    }

    // 초기 체크
    checkTime(target_timestamp);

    // 매 1초마다 체크
    const intervalId = setInterval(() => {
      checkTime(target_timestamp);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [target_timestamp]);

  return { is_time_passed };
}
